// src/app/core/hit-tracking/user-tracking.constants.ts

// All actions used in tracking
export const USER_TRACKING_ACTIONS = {
  CLOSE: 'Close Wizard',
  CLOSE_SETUP_VOLUME: 'Close Sales Volume Wizard',
  CLOSE_KEY_INDICATOR: 'Close Key Indicator Wizard',
  CLOSE_MAP: 'Close Map Preferences Wizard',
  NEXT: 'Next Button Clicked',
  ABANDON: 'Abandon Setup',
  OPEN  : 'Open Section',
  FINISH_SETUP: 'Complete Setup',
  OPT_OUT: 'Opt-out in Start Setup',
  OPT_OUT_FINISH: 'Opt-out in Complete Setup page',
  OPT_IN_FINISH: 'Opt-in in complete Setup page',
  OPT_IN_WELCOME: 'Opt-in in Start Setup',
  OPT_OUT_VOLUME_PAGE: 'Opt-out in Volume Page',
  OPT_IN_VOLUME_PAGE: 'Opt-in in Volume Page',
  OPT_OUT_KEY_INDICATOR: 'Opt-out in Key Indicator Page',
  OPT_IN_KEY_INDICATOR: 'Opt in Key Indicator Page',
  OPT_OUT_MAPS: 'Opt-out in Maps Page',
  OPT_IN_MAPS: 'Opt-in in Maps Page',
  SAVED_SEARCH_SELECTED: 'Select Search',
  SAVED_SEARCH_UPDATED: 'Update Search',
  SAVED_SEARCH_DELETED: 'Delete Search',
  ASSET_REVIEW_BANNER_CLICK: 'Asset Review Banner CTA click',
  ASSET_REVIEW_DROPDOWN_CLICK: 'Asset Review dropdown CTA click',
  ASSET_REVIEW_DOWNLOAD: 'Download',
  ASSET_REVIEW_GO_BACK: 'Go back click',
  ASSET_REVIEW_TRY_AGAIN: 'Try Again click',
  ASSET_REVIEW_GLOSSARY_OPEN: 'Open Glossary accordion',
  ASSET_REVIEW_OVERALL_GRADE_OPEN: 'Open Overall grade accordion',
  ASSET_REVIEW_OPEN_NEW_TAB: 'Open in new tab click',
  ASSET_REVIEW_OPEN_EXPAND_VIEW: 'Expand Panel click',
  CREATE: 'Create Collection',
  DELETE: 'Delete Collection',
  UPDATE: 'Update Collection',
  FAVORITE: 'Favorite',
  UNFAVORITE: 'Unfavorite',
  FILTER_CHANGE: 'Filter changed',
  EXPORT_STORES: 'Export',
  SHARE_STORE_URL: 'Share',
  CLICK_EVENT: 'Click Event',
  CLICK_CRITICAL_INSIGHT: 'Click Critical Insight',
  CLICK_HIGHLIGHT: 'Click Highlight',
  CLICK_MARKER:'Click Marker',
  DEMOGRAPHICS_LOADED: 'Demographics loaded',
  DEMOGRAPHIC_REGION_CHANGED: 'Region changed',
  DEMOGRAPHIC_DETAILS_LOADED: 'Demographic details loaded',
  REGION_OR_COMPARISON_CHANGED: 'Region or comparison changed',
  FILTER_ADDED: 'Filter added',
  FILTER_CHANGED: 'Filter changed',
  CHANGING_BANNER: 'Changing Banner',
  SELECT_SAVED_COLLECTION: 'Selecting a saved collection',
  CLEAR_SALES_VOLUME: 'Clearing Sales Volume',
  CLEAR_SALES_SQFT: 'Clearing Sales Sqft',
  CLEAR_SALES_AREA: 'Clearing Sales Area',
  CLEAR_TOTAL_AREA: 'Clearing Total Area',
  CLEAR_COLLECTION:'Clearing Collections',
  CLEAR_STATUS: 'Clearing Statuses',
  CLEAR_FIT: 'Clearing FIT',
  CLEAR_BANNER: 'Clearing Banners',
  CHANGE_FIT_FILTERS: 'Changing FIT filters',
  LAYER_ENABLED: 'Layer enabled',
  LAYER_DISABLED: 'Layer disabled',
  SEARCH: 'Search',
  PIN_DROP_ENABLED: 'Pin drop enabled',
  SELECTION_ACTION: 'Selection ',
  COMPETITIVE_SUMMARY_CHANGED: 'Competitive summary changed',
  PROJECT_GROCERY_SALES: 'Project grocery sales',
  EXPORT_DATA: 'Export Data',
  VIEW_STORE_DETAILS: 'View Store Details',
  MULTIPLE_STORE_DETAILS: 'Multiple store seletion',
  UPDATE_USER_PREFERENCE: 'Update user preference',
  LOGIN: 'Login',
  LOGOUT: 'Logout',
  PIN_DROP_MODE_DISABLED: 'Pin drop mode disabled',
  SUBMIT: 'Profile Updated',
  //RankByStore
  COMPARISON_CHANGED: 'Changed Sales Performance comparison',
  COMPREHENSIVE_CLICKED: 'Ranking viewed',
  RBS_FILTER_CHANGED: 'Ranking chart modified',
  RBS_CHART_CHANGED: 'Competitive analysis View changed',
  RBS_SALES_VIEW_CHANGED: 'Rank sales view changed',
  RBS_RANKING_MILES_CHANGED: 'Miles changed',
  RBS_RANKING_MINUTES_CHANGED: 'Minutes changed',
  RBS_DETAIL_REPORT_OPENED: 'Store Ranking Viewed',
  RBS_COLUMN_SORT_CHANGED: 'Table sort changed',
  RBS_ONTOP_TOGGLE: 'Always On Top Disabled',
  RBS_RANKING_DATA_EXPORTED: 'Data Exported',
  RBS_RANK_PLOT_CLICK: 'Rank plot clicked',
  RBS_EXPAND_ICON_CLICK: 'Rank Expanded',
  RBS_FILTER_APPLIED: 'Filters Applied',
  RBS_FILTER_RESET_GLOBAL: 'Filters Reset: Global',
  RBS_FILTER_RESET_CATEGORY: 'Filters Reset: Category'
};

// All sources (features/pages)
export const USER_TRACKING_SOURCES = {
  FIRST_TIME_SETUP: 'Welcome Wizard',
  FIRST_TIME_SETUP_VOLUME: 'Welcome Sales Volume Wizard',
  FIRST_TIME_KEY_INDICATOR: 'Welcome Key Indicators Wizard',
  FIRST_TIME_MAP: 'Welcome Maps Preferences Wizard',
  FINISH: 'Finish Page',
  SAVED_SEARCH: 'Map-search ~ Save filter Change',
  MARKER: 'Map-search ~ Marker',
  ASSET_REVIEW: 'Map-search ~ Store Spotlight ~ Asset Review',
  VIEW_DETAILS: 'Map-search ~ Store Spotlight ~ View Details',
  OTHER_STORE: 'Map-search ~ Store Spotlight ~ Other Stores at this location',
  PROFILE_EDIT:'Profile ~ Edit Profile',
  COLLECTION: 'Collection',
  COLLECTION_CREATE_WIZARD: 'Collection ~ Create ~ Collection Wizard',
  COLLECTION_EDIT_WIZARD: 'Collection ~ Edit ~ Collection Wizard',
  STORE_EXPORT_WIZARD: 'Map-search ~ Actions ~ Store Export Wizard',
  STORE_ACTIONS_COLLECTIONS : 'Map-search ~ Actions ~ Add to Collecttion',
  STORE_ACTIONS_MENU: 'Map-search ~ Actions ~ Share',
  STORE_ADDITIONAL_INSIGHTS_PANEL: 'Store Details ~ Additional Insights',
  STORE_NEED_MORE_INSIGHT : 'Store Details ~ Need More Insight',
  STORE_DETAILS_CRITICAL_INSIGHTS: 'Store Details ~ Critical Insights',
  STORE_DETAILS_HIGHLIGHTS: 'Store Details ~ Highlights Panel',
  STORE_DEMOGRAPHIC_PROFILE_PANEL: 'Store Details ~ Demographic Profile Panel',
  DEMOGRAPHIC_DETAILS_PAGE: 'Store Details ~ Demographic Details Page',
  STORE_SALES_PERFORMANCE_PANEL: 'Store Details ~ Sales Performance Panel',
  COMPETITIVE_ANALYSIS_DETAILS_PAGE: 'Store Details ~ Competitive Analysis',
  STORE_DETAIL_ACTIONS_MENU: 'Map-detail ~ Actions ~ Share',
  STORE_DETAIL_EXPORT_WIZARD: 'Map-detail ~ Actions ~ Store Export Wizard',
  STORE_DETAIL_COLLECTIONS : 'Map-detail ~ Actions ~ Add to Collecttion',
  ADD_SAVED_SEARCH_PAGE: 'Map-search ~ Create Saved Search Filter',
  AREA_FILTERS_ASSEMBLY: 'Map-search ~ Area Filters',
  MAP_SEARCH: 'Map-search',
  MAP_LAYERS_ASSEMBLY: 'Map-search ~ Layers',
  GOOGLE_SEARCH: 'Map-search ~ Search',
  MAP_CONTROLS_TOOLBAR: 'Map-search ~ Vertical Map Controls Toolbar',
  MAP_SELECTION_TOOLS: 'Map-search ~ Vertical Map Controls Toolbar',
  COMPETITIVE_ANALYSIS_COMPONENT: 'Store Details ~ Competitive Analysis',
  STORE_ADD_COMPONENT: 'Map-search ~ Project Grocery Sales Wizard',
  SALES_PROJECTION_EXPORT: 'Map-search ~ Project Grocery Sales Wizard',
  STORE_SPOTLIGHT_PANEL: 'Map-search ~ Project Grocery Sales Wizard ~ Store Spotlight Panel',
  STORE_FEATURE_CARD: 'Map-search ~ Multi select store',
  STORE_MULTI_SELECT_SPOTLIGHT_CARD: 'Map-search ~ Multi select Spotlight Panel',
  USER_PREFERENCES: 'Profile ~ User Preferences',
  AUTHENTICATION_SERVICE: 'Header ~ Sign Out',
  RS_W :'RS-Website',
  //RankByStore
  RBS_COMPREHENSIVE_RANKING: 'Store Details ~ Comprehensive Ranking table',
};

// All descriptions corresponding to actions
export const USER_TRACKING_ACTION_DESCRIPTIONS: any = {
  [USER_TRACKING_ACTIONS.CLOSE]: 'User Closed the Welcome Wizard',
  [USER_TRACKING_ACTIONS.CLOSE_SETUP_VOLUME]: 'User Closed the Sales Volume Preferences Wizard',
  [USER_TRACKING_ACTIONS.CLOSE_KEY_INDICATOR]: 'User Closed the Key Indicator Preferences Wizard',
  [USER_TRACKING_ACTIONS.CLOSE_MAP]: 'User Closed the Map Preferences Wizard',
  [USER_TRACKING_ACTIONS.FINISH_SETUP]: 'User Completed the setup',
  USER_TRACKING_ACTIONS_NEXT_START: 'User proceeded from the start page',
  USER_TRACKING_ACTIONS_NEXT_VOLUME: 'User proceeded from the volume page',
  USER_TRACKING_ACTIONS_NEXT_KEY_INDICATORS: 'User proceeded from the key indicators page',
  USER_TRACKING_ACTIONS_NEXT_MAPS: 'User proceeded from the maps page',
  [USER_TRACKING_ACTIONS.ABANDON]: 'User abandoned setup from the volume page',
  [USER_TRACKING_ACTIONS.OPT_OUT]: 'User opted to not show setup again from Welcome Page',
  [USER_TRACKING_ACTIONS.OPT_IN_WELCOME]: 'User again wanted to see setup from Welcome Page',
  [USER_TRACKING_ACTIONS.OPT_OUT_FINISH]: 'User opted to not show setup again from Complete Setup Page',
  [USER_TRACKING_ACTIONS.OPT_IN_FINISH]: 'User again wanted to see setup from Complete Setup Page',
  [USER_TRACKING_ACTIONS.OPT_OUT_VOLUME_PAGE]: 'User opted to not show setup again from Sales Volume Page',
  [USER_TRACKING_ACTIONS.OPT_IN_VOLUME_PAGE]: 'User again wanted to see setup from Sales Volume Page',
  [USER_TRACKING_ACTIONS.OPT_OUT_KEY_INDICATOR]: 'User opted to not show setup again from Key Indicator Page',
  [USER_TRACKING_ACTIONS.OPT_IN_KEY_INDICATOR]: 'User again wanted to see setup from Key Indicator Page',
  [USER_TRACKING_ACTIONS.OPT_OUT_MAPS]: 'User opted to not show setup again from Maps Page',
  [USER_TRACKING_ACTIONS.OPT_IN_MAPS]: 'User again wanted to see setup from Maps Page',
  [USER_TRACKING_ACTIONS.SAVED_SEARCH_SELECTED]: 'Saved search selected',
  [USER_TRACKING_ACTIONS.SAVED_SEARCH_UPDATED]: 'Saved search updated',
  [USER_TRACKING_ACTIONS.SAVED_SEARCH_DELETED]: 'Saved search deleted',
  [USER_TRACKING_ACTIONS.ASSET_REVIEW_BANNER_CLICK]: 'User opened Asset Review via Try Now box',
  [USER_TRACKING_ACTIONS.ASSET_REVIEW_DROPDOWN_CLICK]: 'User opened Asset Review via Actions dropdown menu',
  [USER_TRACKING_ACTIONS.ASSET_REVIEW_GO_BACK]: 'User clicked Go back button',
  [USER_TRACKING_ACTIONS.ASSET_REVIEW_TRY_AGAIN]: 'User clicked Try Again button',
  [USER_TRACKING_ACTIONS.ASSET_REVIEW_GLOSSARY_OPEN]: 'User opened the Glossary accordion',
  [USER_TRACKING_ACTIONS.ASSET_REVIEW_DOWNLOAD]: (format: string) => `User downloaded ${format} report`,
  [USER_TRACKING_ACTIONS.ASSET_REVIEW_OVERALL_GRADE_OPEN]: 'User opened the Overall grade accordion',
  [USER_TRACKING_ACTIONS.ASSET_REVIEW_OPEN_NEW_TAB]: 'User clicked on the open in new tab button',
  [USER_TRACKING_ACTIONS.ASSET_REVIEW_OPEN_EXPAND_VIEW]: 'User clicked on the expand view button',
  [USER_TRACKING_ACTIONS.CREATE]: 'User created a collection',
  [USER_TRACKING_ACTIONS.UPDATE]: 'User updated a collection',
  [USER_TRACKING_ACTIONS.DELETE]: 'Collection deleted',
  [USER_TRACKING_ACTIONS.FAVORITE]: 'Collection marked as favorite',
  [USER_TRACKING_ACTIONS.UNFAVORITE]: 'Collection removed from favorites',
  [USER_TRACKING_ACTIONS.FILTER_CHANGE]: 'Collection filters updated',
  [USER_TRACKING_ACTIONS.SHARE_STORE_URL]: (storeUuid: string) =>
    `User copied the share link for store ${storeUuid}`,
  [USER_TRACKING_ACTIONS.EXPORT_STORES]: (count: number, includeRatings: boolean, includeServices: boolean) =>
    `User exported ${count} store(s) with ratings: ${includeRatings}, services: ${includeServices}`,
  [USER_TRACKING_ACTIONS.CLICK_EVENT]: (eventName: string) => `User clicked on ${eventName}`,
  [USER_TRACKING_ACTIONS.CLICK_CRITICAL_INSIGHT]: (actionDescription: string) =>
    actionDescription || 'User clicked in the Store Details - Critical Insights section',
  [USER_TRACKING_ACTIONS.CLICK_HIGHLIGHT]: (highlightTitle: string) =>
    `User clicked on ${highlightTitle}`,
  [USER_TRACKING_ACTIONS.DEMOGRAPHICS_LOADED]: 'Demographic data loaded',
  [USER_TRACKING_ACTIONS.DEMOGRAPHIC_REGION_CHANGED]: 'User changed the demographic region ',
  [USER_TRACKING_ACTIONS.DEMOGRAPHIC_DETAILS_LOADED]: 'User viewed the Demographic Details page',
  [USER_TRACKING_ACTIONS.REGION_OR_COMPARISON_CHANGED]: 'User changed a region or comparison type in the store details page or initialized it',
  [USER_TRACKING_ACTIONS.FILTER_ADDED]: 'User added a new filter',
  FILTER_CHANGED_SALES_AREA: (min: number, max: number, isExclusive: boolean) =>
    `Sales area filter updated to ${min} - ${max}${isExclusive ? ' (exclusive)' : ''}`,
   FILTER_CHANGED_TOTAL_AREA: (min: number, max: number, isExclusive: boolean) =>
    `Total area filter updated to ${min} - ${max}${isExclusive ? ' (exclusive)' : ''}`,
  SALES_VOLUME_CLEAR_CLICKED: 'Sales Volume Clear Button Clicked',
  SALES_SQFT_CLEAR_CLICKED: 'Sales/Sqft Clear Button Clicked',
  SALES_AREA_CLEAR_CLICKED: 'Sales Area Clear Button Clicked',
  SALES_TOTAL_CLEAR_CLICKED: 'Total Area Clear Button Clicked',
  BANNER_CLEAR_CLICKED: 'Banner Filter Clear Button Clicked',
  FIT_CLEAR_CLICKED: 'FIT Filter Clear Button Clicked',
  STATUS_CLEAR_CLICKED: 'Status Filter Clear Button Clicked',
  COLLECTION_CLEAR_CLICKED: 'Collection Filter Clear Button Clicked',
  BANNERS: 'Banners',
  COLLECTIONS: 'Collections',
  FIT_CATEGORIES: 'FIT categories',
  [USER_TRACKING_ACTIONS.LAYER_ENABLED]: (layerName: string) => `Layer "${layerName}" enabled`,
  [USER_TRACKING_ACTIONS.LAYER_DISABLED]: (layerName: string) => `Layer "${layerName}" disabled`,
  [USER_TRACKING_ACTIONS.FILTER_CHANGED]: {
    SALES_VOLUME: 'Sales volume filter updated',
    STATUS_FILTER: 'Status filter updated',
    SALES_SQFT : 'Sales/Sqft filter updated'
  },
  [USER_TRACKING_ACTIONS.SEARCH]: 'User searched for a new location in Google Maps',
  [USER_TRACKING_ACTIONS.PIN_DROP_ENABLED]: 'Pin drop mode enabled',
  [USER_TRACKING_ACTIONS.SELECTION_ACTION]: 'User performed a selection action on the map',
  [USER_TRACKING_ACTIONS.COMPETITIVE_SUMMARY_CHANGED]: 'User changed the filter in competitive analysis',
  [USER_TRACKING_ACTIONS.PROJECT_GROCERY_SALES]: 'User projected grocery sales',
  [USER_TRACKING_ACTIONS.EXPORT_DATA]: 'User exported Excel report with form, summary, competition, and demographics',
  [USER_TRACKING_ACTIONS.VIEW_STORE_DETAILS]: 'User clicked View Details',
  [USER_TRACKING_ACTIONS.MULTIPLE_STORE_DETAILS]: 'User selecting multiple store by different selection types',
  [USER_TRACKING_ACTIONS.UPDATE_USER_PREFERENCE]: (field: string, newValue: any) =>
    `User updated preference "${field}" to "${newValue}"`,
  [USER_TRACKING_ACTIONS.LOGIN]: 'User logged in',
  [USER_TRACKING_ACTIONS.LOGOUT]: 'User logged out',
  [USER_TRACKING_ACTIONS.PIN_DROP_MODE_DISABLED]: 'Pin drop mode disabled',
  [USER_TRACKING_ACTIONS.CLICK_MARKER]: 'User clicked on a store marker on map search',
  [USER_TRACKING_ACTIONS.OPEN]: 'User opened the "Other Stores At This Location" accordion',
  [USER_TRACKING_ACTIONS.SUBMIT]: 'User submitted profile edit form',
  //RankByStore
  [USER_TRACKING_ACTIONS.COMPARISON_CHANGED]: 'Dropdown item selection changed',
  [USER_TRACKING_ACTIONS.COMPREHENSIVE_CLICKED]: 'User clicks the CTA',
  [USER_TRACKING_ACTIONS.RBS_FILTER_CHANGED]: 'User changes default selection from the dropdown controlling the dot plot chart',
  [USER_TRACKING_ACTIONS.RBS_CHART_CHANGED]: 'User chooses to switch between table view and the chart view',
  [USER_TRACKING_ACTIONS.RBS_SALES_VIEW_CHANGED]: 'User uses the tab switcher to change the sales volume data between Annual or Weekly.',
  [USER_TRACKING_ACTIONS.RBS_RANKING_MILES_CHANGED]: 'User changed the miles value',
  [USER_TRACKING_ACTIONS.RBS_RANKING_MINUTES_CHANGED]: 'User changed the minutes value',
  [USER_TRACKING_ACTIONS.RBS_DETAIL_REPORT_OPENED]: 'User clicks on store name which opens a popup that shows ranking summary for the banner comparing with other stores of same banner and across all banners in the industry',
  [USER_TRACKING_ACTIONS.RBS_COLUMN_SORT_CHANGED]: 'User sorts data by a specific column',
  [USER_TRACKING_ACTIONS.RBS_ONTOP_TOGGLE]: 'User opts to unfreeze the current store info on top of the table',
  [USER_TRACKING_ACTIONS.RBS_RANKING_DATA_EXPORTED]: 'User exported data from the export dropdown',
  [USER_TRACKING_ACTIONS.RBS_RANK_PLOT_CLICK]: 'User clicks on the dots on the rank chart to view store details',
  [USER_TRACKING_ACTIONS.RBS_EXPAND_ICON_CLICK]: 'User clicks to expand rank to check the ranking of other stores and its position.',
  [USER_TRACKING_ACTIONS.RBS_FILTER_APPLIED]: 'User clicks "Apply" button to execute filters',
  [USER_TRACKING_ACTIONS.RBS_FILTER_RESET_GLOBAL]: 'User clicks the main "Reset" button in top-right corner of filter panel',
  [USER_TRACKING_ACTIONS.RBS_FILTER_RESET_CATEGORY]: 'User clicks category-specific "RESET" button within a filter tab',
};
